export const ROUTES = {
    home: '/'
};
